import {Plugin} from "ckeditor5";
import {ButtonView} from "ckeditor5";

export class MarkForTechnician extends Plugin {
  toolbarIcon = '<svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" fill="#e53935"><path d="M3 17.25V19h18v-1.75ZM3 12.5v1.75h18V12.5ZM3 7.75V9.5h18V7.75Z"/></svg>';

  init() {
    const editor = this.editor;
    editor.ui.componentFactory.add('MarkForTechnician', locale => {
      const view = new ButtonView(locale);
      view.set({
        label: 'Mark for Technician',
        tooltip: true,
        withText: true,
      });

      view.on('execute', () => {
        const selection = editor.model.document.selection;
        let selectedText = '';

        for (const range of selection.getRanges()) {
          for (const item of range.getItems()) {
            if (item.is('$textProxy')) {
              selectedText += item.data;
            }
          }
        }

        if (!selectedText) return;

        // Zeilenumbrüche am Anfang/Ende
        let text = selectedText;
        if (!text.startsWith('\n')) text = '\n' + text;
        if (!text.endsWith('\n')) text = text + '\n';

        // Ersetze \n durch <br>
        const htmlText = text.replace(/\n/g, '<br>');

        // HTML-Struktur
        const html =
          `<div>
            <br />
            <br />
            <div style="font-weight:bold;">Hinweis:</div>
            <span style="color:red;">${htmlText}</span>
            <br />
          </div>`;

        editor.model.change(writer => {
          editor.model.deleteContent(selection);
          const viewFragment = editor.data.htmlProcessor.toView(html);
          const modelFragment = editor.data.toModel(viewFragment);
          editor.model.insertContent(modelFragment, selection.getFirstPosition());
        });
      });

      return view;
    });
  }
}
